import aT from '../const/action-type'
import initial from '../store/initial'
//
export default (state = initial.modal, action) => {
  switch (action.type) {
    case aT.SET_MODAL:
      return action.data
    case aT.RESET_STORE:
      return initial.modal
    case aT.SWITCH_WORKSPACE:
      return initial.modal
    default:
      return state
  }
}
